import { Edit, Send, Delete } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import "./ShortlistStory.scss";
import moment from "moment/moment";
import { RouteComponentProps, withRouter } from "react-router";
import black from "../../icons/default1.png";
import Dropdown from "../Main/Dropdown/Dropdown";
import config from "../../config/apiConfig";
import Cookies from "js-cookie";
import ReactGA from "react-ga";

export type SList = {
    id: string;
    avatar: string;
    title: string;
    updatedAt: Date;
};

type Props = {
    drafts: SList[];
    publish: (id: string) => any;
    delete: (id: string) => any;
};

type Part = {
    id: string;
    title: string;
};

export function mapToSL(data: { [key: string]: any }): SList {
    return {
        id: data.storyId,
        avatar: !!data.imageUrl
            ? "https://apis.serendipitymedia.tech/assets/" + data.imageUrl
            : "",
        title: data.title,
        updatedAt: new Date((data.updated_at ?? 0) * 1000),
    };
}

const Shortlist: React.FC<Props & RouteComponentProps> = ({
    drafts,
    history,
    publish,
    delete: onDelete,
}) => {
    return (
        <React.Fragment>
            {drafts.map((draft, index) => (
                <div className="draft">
                    <div className="image">
                        <img
                            src={
                                draft.avatar.trim() !== ""
                                    ? draft.avatar
                                    : black
                            }
                        />
                    </div>
                    <div className="content">
                        <h5>
                            {draft.title.length > 80
                                ? draft.title.substr(0, 80) + "..."
                                : draft.title}
                        </h5>
                        <p>
                            Published on{" "}
                            {moment(draft.updatedAt).format(
                                "Do MMMM YYYY [at] h:mm a"
                            )}
                        </p>
                        <div className="flex">
                            <div className="concat-buttons">
                                <button
                                    onClick={() => {
                                        ReactGA.event({
                                            category: "My Stories",
                                            action: "View published",
                                            label: draft.id,
                                        });
                                        history.push(
                                            "/producer/read/" + draft.id
                                        );
                                    }}
                                >
                                    Read reviews
                                </button>
                                <button
                                    style={{
                                        background: config.primary_color,
                                        color: "#ffffff",
                                    }}
                                    onClick={() => publish(draft.id)}
                                >
                                    Select Story
                                </button>
                            </div>
                            <button
                                onClick={() => onDelete(draft.id)}
                                className="icon_button"
                            >
                                <Delete />
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
};

export default withRouter(Shortlist);
